import { buildSliceDirectoryPath } from "./buildSliceDirectoryPath.js";
import { deleteProjectFile } from "./deleteProjectFile.js";
const deleteSliceDirectory = async (args) => {
  const dir = await buildSliceDirectoryPath(args);
  const relativeDir = await buildSliceDirectoryPath({
    ...args,
    absolute: false
  });
  await deleteProjectFile({
    filename: relativeDir,
    helpers: args.helpers
  });
  return dir;
};
export {
  deleteSliceDirectory
};
//# sourceMappingURL=deleteSliceDirectory.js.map
